var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xE9chelle",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ecc09b;}.cls-2{fill:#af7f5b;opacity:0.61;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "carton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carton"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 156,
    height: 91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 67,
    width: 21,
    height: 41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 7,
    height: 41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 151,
    width: 5,
    height: 41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 156,
    height: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarton);
export default __webpack_public_path__ + "static/media/carton.b5d80ddc0eff8e111dfd3273847027e4.svg";
export { ForwardRef as ReactComponent };